/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { withRouter } from 'react-router';
import clsx from 'clsx';

class HeaderSkipGreen extends React.Component {
  render() {
    const { isMuted, setMuted } = this.props;

    return (
      <div
        className={`header-skip-green ${css(styles.flex, styles.flex_layout)}`}
      >
        <div className={css(styles.flex_item)}>
          <a
            href="/"
            onClick={() => window.open('/', '_self')}
            style={{
              '--src': `url(${
                require('assets/85c7411b9cef1d470fb3af85e44cc047.svg').default
              })`
            }}
            className={`${css(styles.icon, styles.icon_layout)} close`}
          />
        </div>

        <div className={css(styles.flex_spacer)} />

        <div
          className={`${css(styles.flex_item1)} cursor-pointer`}
          onClick={setMuted}
        >
          <div
            style={{
              '--src': `url(${
                require('assets/05f3808d47f3c11950fb46949240d410.png').default
              })`
            }}
            className={clsx([
              `${css(styles.image, styles.image_layout)} muted`,
              {
                'is-muted': isMuted
              }
            ])}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(HeaderSkipGreen);

HeaderSkipGreen.inStorybook = true;

const styles = StyleSheet.create({
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 33
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat',
    display: 'block'
  },
  icon_layout: {
    height: 25,
    width: 25,
    minWidth: 25,
    margin: '3.5px 4px'
  },
  flex_spacer: {
    flex: '1 1 982px'
  },
  flex_item1: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 24
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 21,
    width: 24,
    minWidth: 24,
    margin: '5.5px 0px'
  }
});
